import { useContext } from 'react';
import { Route } from 'react-router-dom';
import { investmentJoinAndAllocationContext } from '@dealstack/frontend/investor/pages/Investment/InvestmentJoinAndAllocation/InvestmentJoinAndAllocation';
import { KycInstruction } from '@dealstack/frontend/investor/pages/Investment/common/checksComplete/KycInstructions/KycInstruction';
import { JoinAndAllocationPersonalIDs } from '@dealstack/frontend/investor/pages/Investment/InvestmentJoinAndAllocation/JoinAndAllocationChecksComplete/JoinAndAllocationPersonalIDs/JoinAndAllocationPersonalIDs';
import { JoinAndAllocationPIVProof } from '@dealstack/frontend/investor/pages/Investment/InvestmentJoinAndAllocation/JoinAndAllocationChecksComplete/JoinAndAllocationPIVProof/JoinAndAllocationPIVProof';
import { JoinAndAllocationKycForms } from '@dealstack/frontend/investor/pages/Investment/InvestmentJoinAndAllocation/JoinAndAllocationChecksComplete/JoinAndAllocationKycForms/JoinAndAllocationKycForms';
import { JoinAndAllocationDeclarations } from '@dealstack/frontend/investor/pages/Investment/InvestmentJoinAndAllocation/JoinAndAllocationChecksComplete/JoinAndAllocationDeclarations/JoinAndAllocationDeclarations';
import { SentryRoutes } from '@dealstack/frontend/shared/sentry';
import { NoSaveStep } from '@dealstack/frontend/shared/components/Wizard/WizardStepRegistry';
import { getKycWorkflowId } from '@dealstack/frontend/investor/pages/Investment/common/getKycWorkflowId';
import { InlineLoader } from '@dealstack/frontend/shared/components/loaders/InlineLoader/InlineLoader';
import { isAnyCertificationRequired } from '@dealstack/shared/lib/common/business/kycCertification';

export enum JOIN_ALLOCATION_CHECKS_COMPLETE_ROUTES {
	INSTRUCTIONS = '/instructions',
	PERSONAL = '/personal',
	COMPANY = '/company',
	KYC_FORMS = '/kyc-forms',
	DECLARATIONS = '/declarations',
}

interface Props {
	className?: string;
}

export const JoinAndAllocationChecksComplete = ({ className }: Props) => {
	const { kycSetting, investmentDetails } = useContext(investmentJoinAndAllocationContext);

	const isCertifiedCopiesRequested = isAnyCertificationRequired(kycSetting);

	const kycWorkflowId = getKycWorkflowId(investmentDetails);

	if (!kycWorkflowId) {
		return <InlineLoader />;
	}

	return (
		<div className={className}>
			<SentryRoutes>
				<Route
					path={JOIN_ALLOCATION_CHECKS_COMPLETE_ROUTES.INSTRUCTIONS}
					element={
						<NoSaveStep>
							<KycInstruction
								isCertifiedCopiesOfDocumentsRequested={isCertifiedCopiesRequested}
							/>
						</NoSaveStep>
					}
				/>
				<Route
					path={JOIN_ALLOCATION_CHECKS_COMPLETE_ROUTES.PERSONAL}
					element={<JoinAndAllocationPersonalIDs />}
				/>
				<Route
					path={JOIN_ALLOCATION_CHECKS_COMPLETE_ROUTES.COMPANY}
					element={<JoinAndAllocationPIVProof />}
				/>
				<Route
					path={JOIN_ALLOCATION_CHECKS_COMPLETE_ROUTES.KYC_FORMS}
					element={<JoinAndAllocationKycForms />}
				/>
				<Route
					path={JOIN_ALLOCATION_CHECKS_COMPLETE_ROUTES.DECLARATIONS}
					element={<JoinAndAllocationDeclarations />}
				/>
			</SentryRoutes>
		</div>
	);
};
